const context = 'venue'

export const FETCH_VENUES = `${context}/FETCH_VENUES`
export const SELECT_VENUE = `${context}/SELECT_VENUE`
export const FETCH_VENUE_REQUESTED = `${context}/FETCH_VENUE_REQUESTED`
export const FETCH_VENUES_SUCCEEDED = `${context}/FETCH_VENUES_SUCCEEDED`
